import { withAuthenticationRequired } from '@auth0/auth0-react';
import { FC } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Loading } from '../../components/loaders';
import { DataSourcesRouter } from '../../features/dataSources';
import { Assistant, AssistantFeatureGate } from '../assistant';
import { AudiencesRouter } from '../audiences';
import { CampaignPerformanceRouter, useCampaignPerformanceEnabled } from '../campaignPerformance';
import { CampaignsRouter } from '../campaigns';
import { ComuniRouter, useComuniEnabled } from '../comuni';
import CompanyCreation from '../company/components/CompanyCreation';
import CyclrAuthRedirect from '../cyclr/CyclrAuthRedirect';
import { DestinationsRouter } from '../destinations';
import { HomePage } from '../home';
import { workspaceSectionAccess } from './workspaceSectionAccess';
import Logout from '../logout/Logout';
import { MarketIntelligenceRouter, useMarketIntelligenceEnabled } from '../marketIntelligence';
import { PerformanceAudiencePage } from '../performanceAudience';
import { PrivateRoute } from '../router/components';
import RouteConstants from '../router/RouteConstants';
import { SettingsRouter } from '../settings';
import { useUserInfo } from '../userInfo/hooks';
import { WhatsappInboxRouter, useWhatsappInboxEnabled } from '../whatsappInbox';
import WorkspaceCreation from '../workspaceEdit/WorkspaceCreation';

// Same guard as PrivateRoute, built once at module scope: PrivateRoute re-wraps on every render, which would
// remount the inbox (losing search text and scroll) on each navigation inside it.
const GuardedWhatsappInbox = withAuthenticationRequired(WhatsappInboxRouter, { onRedirecting: () => <Loading /> });

const RedirectHome: FC = () => <Redirect to={RouteConstants.home} />;

export const LayoutRoutes: FC = () => {
  const userInfo = useUserInfo();
  const campaignPerformanceEnabled = useCampaignPerformanceEnabled();
  const comuniEnabled = useComuniEnabled();
  const marketIntelligenceEnabled = useMarketIntelligenceEnabled();
  const sectionAccess = workspaceSectionAccess({ comuni: comuniEnabled, marketIntelligence: marketIntelligenceEnabled });
  const whatsappInboxEnabled = useWhatsappInboxEnabled();

  return (
    <>
      <PrivateRoute path={RouteConstants.logout} component={Logout} />
      {!userInfo.onboard ? (
        <Loading />
      ) : (
        <>
          <PrivateRoute path={RouteConstants.home} component={HomePage} />
          <PrivateRoute path={RouteConstants.campaigns} component={CampaignsRouter} />
          <PrivateRoute path={RouteConstants.createCompany} component={CompanyCreation} />
          <PrivateRoute path={RouteConstants.createWorkspace} component={WorkspaceCreation} />
          <PrivateRoute path={RouteConstants.dataSources} component={DataSourcesRouter} />
          <PrivateRoute path={RouteConstants.audiences} component={AudiencesRouter} />
          <PrivateRoute path={RouteConstants.destinations} component={DestinationsRouter} />
          <PrivateRoute path={RouteConstants.marketIntellingence} component={sectionAccess.marketIntelligence ? MarketIntelligenceRouter : RedirectHome} />
          <PrivateRoute path={RouteConstants.performanceAudience} component={PerformanceAudiencePage} />
          {campaignPerformanceEnabled ? <PrivateRoute path={RouteConstants.campaignPerformance} component={CampaignPerformanceRouter} /> : null}
          <PrivateRoute path={RouteConstants.comuni} component={sectionAccess.comuni ? ComuniRouter : RedirectHome} />
          {whatsappInboxEnabled ? <Route path={RouteConstants.whatsappInbox} component={GuardedWhatsappInbox} /> : null}
          <PrivateRoute path={RouteConstants.settings} component={SettingsRouter} />
          <PrivateRoute path={RouteConstants.cyclrAuthRedirect} component={CyclrAuthRedirect} />

          <AssistantFeatureGate>
            <Assistant />
          </AssistantFeatureGate>
        </>
      )}
    </>
  );
};
